import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  formValueSelector,
  initialize,
  change,
} from 'redux-form';
import { injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../Link';
import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';
import { demoRestriction } from '../../../actions/demoRestriction';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';

import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';
import { api, categoryUploadDir } from '../../../config';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';

//images
import bt from '../../../components/commonStyle.css';
import s from './AddCategoryForm.css';


export class AddCategoryForm extends Component {
  static defaultProps = {
    currency: 'USD',
    loading: false,
  };

  constructor(props) {
    super(props);
    this.successLogo = this.successLogo.bind(this);
    this.successBanner = this.successBanner.bind(this);
  }

  async successLogo(file, fromServer) {
    const { change, updateTempImages, demoRestriction, id } = this.props;
    if (id) {
      const isRestrict = await demoRestriction({ restrictType: 'category', restrictValue: id });
      if (isRestrict) return;
    }
    await change('logoImage', fromServer && fromServer.fileName);
    await updateTempImages(
      'Category',
      'logoImage',
      fromServer && fromServer.fileName,
    );
  }

  async successBanner(file, fromServer) {
    const { change, updateTempImages, demoRestriction, id } = this.props;
    if (id) {
      const isRestrict = await demoRestriction({ restrictType: 'category', restrictValue: id });
      if (isRestrict) return;
    }
    await change('bannerImage', fromServer && fromServer.fileName);
    await updateTempImages(
      'Category',
      'bannerImage',
      fromServer && fromServer.fileName,
    );
  }

  render() {
    const { handleSubmit, currency, logoImage, bannerImage, loading, submitting, id, userIdentityLoading, userExperienceLoading } = this.props;
    const { formatMessage } = this.props.intl;

    const categoryOptions = [
      { value: false, label: formatMessage(messages.no) },
      { value: true, label: formatMessage(messages.yes) }
    ]
    const currencyOptions = currency && currency?.availableCurrencies?.filter(item => item?.isEnable).map(item => {
      return {
        value: item?.symbol,
        label: item?.symbol
      }
    })
    const pricingTypeOptions = [
      { value: 'fixed', label: formatMessage(messages.fixedFareType) },
      { value: 'hourly', label: formatMessage(messages.hourlyFareType) }
    ]

    const statusOption = [
      { value: 'active', label: formatMessage(messages.active) },
      { value: 'inactive', label: formatMessage(messages.inactive) }
    ]

    return (
      <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
        <h1 className='siteAdminPrimaryHeading'>
          {id
            ? formatMessage(messages.editCategory)
            : formatMessage(messages.addCategory)}
        </h1>

        <Row>
          <Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
            <div className={cx(s.profileImgSection, s.profileImgWidth)}>
              <label className={bt.commonLabelText}>
                {formatMessage(messages.categoryLogo)}
              </label>
              <CommonImageDisplay loader={userIdentityLoading} imageSrc={logoImage ? api?.apiEndpoint + categoryUploadDir + 'medium_' + logoImage : null} />
              <ImageUploadComponent
                className='commonSiteAdminDropzoneSpace'
                subText={formatMessage(messages.maximumUploadSizeLabel)}
                defaultMessage={formatMessage(messages.chooseFile)}
                componentConfig={{
                  iconFiletypes: ['.jpg', '.png', '.svg'],
                  multiple: false,
                  showFiletypeIcon: false,
                  postUrl:
                    api.apiEndpoint + '/uploadCategoryLogo',
                }}
                success={this.successLogo}
                loaderName={'userIdentityLoading'}
              />
            </div>

          </Col>
          <Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
            <div className={cx(s.profileImgSection, s.profileImgWidth)}>
              <label className={bt.commonLabelText}>
                {formatMessage(messages.categoryBanner)}
              </label>
              <CommonImageDisplay loader={userExperienceLoading} imageSrc={bannerImage ? api?.apiEndpoint + categoryUploadDir + 'medium_' + bannerImage : null} />
              <ImageUploadComponent
                className='commonSiteAdminDropzoneSpace'
                subText={formatMessage(messages.maximumUploadSizeLabel)}
                defaultMessage={formatMessage(messages.chooseFile)}
                componentConfig={{
                  iconFiletypes: ['.jpg', '.png', '.svg'],
                  multiple: false,
                  showFiletypeIcon: false,
                  postUrl:
                    api.apiEndpoint + '/uploadCategoryBanner',
                }}
                success={this.successBanner}
                loaderName={'userExperienceLoading'}
              />
            </div>
          </Col>
        </Row>

        <div className='twoColumnGrid'>
          <Field
            name="name"
            type="text"
            placeholder={formatMessage(messages.categoryName)}
            component={InputFieldComponent}
            label={formatMessage(messages.categoryName)}
            inputClass={bt.formControlInput}
          />
          <Field
            name="description"
            type="text"
            placeholder={formatMessage(messages.description)}
            component={InputFieldComponent}
            componentClass="textarea"
            label={formatMessage(messages.description)}
            inputClass={bt.formTextArea}
          />
          <Field
            name="isPopular"
            label={formatMessage(messages.isPopular)}
            component={SelectFieldComponent}
            options={categoryOptions}
            inputClass={bt.formControlSelect}
          />
          <Field
            name="isJobPhotoRequired"
            component={SelectFieldComponent}
            options={categoryOptions}
            label={formatMessage(messages.isJobPhotoRequired)}
            inputClass={bt.formControlSelect}
          />
          <Field
            name="currency"
            component={SelectFieldComponent}
            label={formatMessage(messages.currency)}
            options={currencyOptions}
            inputClass={bt.formControlSelect}
          />
          <Field
            name="travellingPrice"
            type="text"
            placeholder={formatMessage(messages.travelCharge)}
            component={InputFieldComponent}
            label={formatMessage(messages.travelCharge)}
            maxLength={5}
            inputClass={bt.formControlInput}
          />
          <Field
            name="userServiceFeeValue"
            type="text"
            placeholder={formatMessage(messages.userServiceFee)}
            component={InputFieldComponent}
            label={formatMessage(messages.userServiceFee)}
            suffixLabel={'%'}
            isAddon
          />
          <Field
            name="partnerServiceFeeValue"
            type="text"
            placeholder={formatMessage(
              messages.partnerServiceFee,
            )}
            component={InputFieldComponent}
            label={formatMessage(messages.partnerServiceFee)}
            suffixLabel={'%'}
            isAddon
          />
          <Field
            name="pricingType"
            component={SelectFieldComponent}
            label={formatMessage(messages.pricingType)}
            options={pricingTypeOptions}
            inputClass={bt.formControlSelect}
          />
          <Field
            name="status"
            component={SelectFieldComponent}
            label={formatMessage(messages.status)}
            options={statusOption}
            inputClass={bt.formControlSelect}
          />
        </div>

        <div className='commonButtonContainer'>
          <Link to={'/siteadmin/category'} className={bt.btnSecondary}  >
            {formatMessage(messages.goBack)}
          </Link>
          <Loader
            type={'button'}
            label={formatMessage(messages.submitButton)}
            show={loading}
            buttonType={'submit'}
            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
            disabled={submitting || loading}
          />
        </div>
      </Form>
    );
  }
}
AddCategoryForm = reduxForm({
  form: 'AddCategoryForm',
  onSubmit: submit,
  validate,
})(AddCategoryForm);

const selector = formValueSelector('AddCategoryForm');

const mapState = state => ({
  currency: state?.currency,
  logoImage: selector(state, 'logoImage'),
  bannerImage: selector(state, 'bannerImage'),
  id: selector(state, 'id'),
  loading: state?.loader?.AddCategory,
  userIdentityLoading: state?.loader?.userIdentityLoading,
  userExperienceLoading: state?.loader?.userExperienceLoading,
});

const mapDispatch = {
  initialize,
  change,
  updateTempImages,
  demoRestriction
};

export default injectIntl(
  withStyles(bt, s)(connect(mapState, mapDispatch)(AddCategoryForm)),
);
